const callFetch = async (url, method = 'GET', data) => {
    const options = {
        method: method.toUpperCase(),
        body: JSON.stringify(data),
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        }
    };
    return fetch(`${process.env.REACT_APP_API_URL}${url}`, options)
};

export function getRegistration(id) {
    return callFetch(`registration/person-data/${id}`)
}

export function postRegistration(data) {
    return callFetch('registration/person-data', 'POST', data)
}

export function putRegistration(data) {
    return callFetch('registration/person-data', 'PUT', data)
}

export function getRegistrationQuestionnaire(id) {
    return callFetch(`registration/questionnaire/${id}`)
}

export function putRegistrationQuestionnaire(id, data) {
    return callFetch(`registration/questionnaire/${id}`, 'PUT', data)
}

export function getSubscriptionPrice(id) {
    return callFetch(`recurly/price/${id}`)
}

export function getRecurlySubscription(id) {
    return callFetch(`recurly/${id}`)
}

export function postRecurlySubscription(data) {
    return callFetch('recurly', 'POST', data)
}

export function getPass(id) {
    return callFetch(`pass/${id}`)
}
